export const convertDataType = (columns: any[], data: any[], filename: string, fieldsToFormat?: string[]) => {
    const columnsToExport = columns.filter(columnDef => columnDef.export !== false && !columnDef.hidden);
    const dataToExport = data.map((row: any) =>
        columnsToExport.map(columnDef => {
            let value;
            if (columnDef.render && columnDef.field) {
                value = columnDef.render(row);
            } else if (columnDef.field) {
                value = columnDef.field.split('.').reduce((agg: any, key: string) => agg && agg[key], row);
            }

            if (value === undefined || value === null) {
                value = "";
            }
            if (fieldsToFormat && fieldsToFormat.includes(columnDef.field)) {
                return `="${value}"`;
            }

            if (typeof value === 'number') {
                return value;
            }

            if (typeof value === 'string') {
                // If string contains comma, or double quotes, it must be quoted.
                if (value.includes(',') || value.includes('"')) {
                    return '"' + value.replace(/"/g, '""') + '"';
                }
                return value; // return as is
            }


            return value;
        })
    );

    let csvContent = "";
    csvContent += columnsToExport.map(c => c.title).join(",") + "\r\n";

    dataToExport.forEach(rowArray => {
        let row = rowArray.join(",");
        csvContent += row + "\r\n";
    });

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", `${filename}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
